/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { colors } from './styles/colors';
import fonts, { fontSizes } from './styles/fonts';
import { lineHeights } from './styles/spacing';

import marginPropStyles, {
  MarginProps
} from './styles/internal/marginPropStyles';
import { overflowEllipsesStyle, TextProps } from './styles/text';
import styled from 'styled-components';

export default styled.p<MarginProps & TextProps>`
  margin: 0;
  ${marginPropStyles}
  font: ${(props) =>
    props.bold ? fonts.bold(fontSizes.body) : fonts.normal(fontSizes.body)};
  color: ${(props) => props.color || colors.grey100};
  line-height: ${lineHeights.body};
  ${({ overflow }) => overflow === 'ellipses' && overflowEllipsesStyle};
`;
